module.exports = __webpack_public_path__ + "static/media/03.ba7012fc.mp3";